import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => (
    {
      cardRightButton: {
        width: "50px",
        borderLeftWidth: 1,
        borderLeftStyle: "solid",
        borderLeftColor: theme.palette.divider,
        margin: '5px 0px 5px 10px',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
          display: "none",
        },
        "& svg": {
          margin: 0,
          width: "22px",
          height: "22px",
          fill: theme.palette.primary.main,
        },
      },
      container: {
        paddingTop: '8px',
        paddingRight: '10px',
        "& .MuiTypography-body1": {
          fontSize: 12
        }
      },
      checkbox:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRight: `1px solid ${theme.palette.divider}`,
        margin: '8px 0',
        marginRight: '10px'
      }
    }
  ))